<template>
  <div>
    <banner
      :items="bannerItems"
      :colorValues="enums.bannerColors"
      :bannerDefaultImgs="config.images.bannerDefault"
      :loading="bannerLoading"
      :bannerDefaultTitle="
        this.config.texts[this.isClient ? 'bannerTitle' : 'syndicBannerTitle']
      "
      :bannerDefaultDescription="
        this.config.texts[
          this.isClient ? 'bannerDescription' : 'syndicBannerDescription'
        ]
      "
    ></banner>
    <units-select> </units-select>
    <warning-compliance
      v-if="compliance && visible && !complianceUser && !acceptedPolicyPrivacy"
      :text="compliance.description"
      :link="compliance.link"
      @accepted="acceptedFunction"
    >
    </warning-compliance>

    <modal
      v-for="modal in visiblesPopups"
      :key="modal.id"
      :title="modal.title"
      width="700"
      :dontShowAgain="true"
      :persistent="true"
      @dontShowAgain="dontShowAgain"
      @input="acceptedPopUpFunction(modal.id, modal.title, modal.description)"
      confirmLabel="OK"
      :value="modalPopup"
      :content="modal.description"
    >
    </modal>

    <v-layout
      class="cards-area"
      :class="{ 'cards-area__lg': $vuetify.breakpoint.lgAndUp }"
      row
      wrap
    >
      <v-progress-circular
        v-if="!unitSegmentations || unitSegmentations.length == 0"
        indeterminate
        class="banner__loader__spinner"
      ></v-progress-circular>
      <template v-else>
        <v-flex
          xs12
          md4
          lg4
          v-if="
            segmentedHomeModules.paymentSlipCard == null ||
            !!segmentedHomeModules.paymentSlipCard
          "
        >
          <payment-slip-card
            :items="toExpirePaymentSlips"
            :hasLateSlips="hasLateSlips"
            :hasAnticipationReadySolicitations="
              hasAnticipationReadySolicitations
            "
            :hasLateReadySolicitations="hasLateReadySolicitations"
            :hasPayableLateSlips="hasPayableLateSlips"
            :hasFuturePaymentSlips="hasFuturePaymentSlips"
            :debitBlock="debitBlock"
            :loading="isLoadingPaymentSlips || gettingModulesInfos"
            :error="hasPaymentSlipError"
            :params="appModules.paymentSlip"
            :errorText="enums.responses.error"
            @paySlip="
              (item) => {
                OnPayToExpireSlip(selectedUnit, item, true);
              }
            "
            :sendSlipByEmail="sendSlipByEmailToExpire"
            :sendSlipBySms="sendSlipBySmsToExpire"
            @visibleChanged="updateModuleVisible('paymentSlipCard', $event)"
            :retryFunction="getToExpirePaymentSlips"
          ></payment-slip-card>
        </v-flex>
        <v-flex
          xs12
          md4
          lg4
          v-if="
            segmentedHomeModules.financialSummaryCard == null ||
            !!segmentedHomeModules.financialSummaryCard
          "
        >
          <financial-summary-card
            :item="financialSummaryItems"
            :loading="financialSummaryLoading"
            :error="financialSummaryError"
            :params="appModules.financialPosition"
            :errorText="enums.responses.error"
            :retryFunction="getFinancialSummary"
            @visibleChanged="
              updateModuleVisible('financialSummaryCard', $event)
            "
          ></financial-summary-card>
        </v-flex>
        <v-flex
          xs12
          md4
          lg4
          v-if="
            segmentedHomeModules.supportCard == null ||
            !!segmentedHomeModules.supportCard
          "
        >
          <support-card
            :item="supportItems"
            :loading="supportLoading"
            :error="supportError"
            :params="appModules.support"
            :errorText="enums.responses.error"
            :retryFunction="getOctadeskAllProposersTickets"
            @visibleChanged="updateModuleVisible('supportCard', $event)"
          ></support-card>
        </v-flex>
        <v-flex
          xs12
          md4
          lg4
          v-if="
            (segmentedHomeModules.myEnterpriseCard == null ||
              (!!segmentedHomeModules.myEnterpriseCard && enterpriseAllowed)) &&
            myEnterpriseIframeUrl
          "
        >
          <my-enterprise-card
            :iframeUrl="myEnterpriseIframeUrl"
            :tourUrl="tourUrl"
            :loading="enterpriseLoading"
            :lastUpdate="enterpriseLastUpdate"
            :params="appModules.myEnterprise"
            @visibleChanged="updateModuleVisible('myEnterpriseCard', $event)"
          ></my-enterprise-card>
        </v-flex>
        <v-flex
          xs12
          md4
          lg4
          v-if="
            (segmentedHomeModules.inConstructionCard == null ||
              (!!segmentedHomeModules.inConstructionCard &&
                enterpriseAllowed)) &&
            constructionIframeUrl
          "
        >
          <construction-card
            :iframeUrl="constructionIframeUrl"
            :loading="enterpriseLoading"
            :params="appModules.constructionProgress"
            @visibleChanged="updateModuleVisible('inConstructionCard', $event)"
          ></construction-card>
        </v-flex>
        <v-flex
          xs12
          md4
          lg4
          v-if="
            (segmentedHomeModules.decoratedCard == null ||
              (!!segmentedHomeModules.decoratedCard && enterpriseAllowed)) &&
            decoratedIframeUrl
          "
        >
          <decorated-card
            :iframeUrl="decoratedIframeUrl"
            :tourUrl="tourUrl"
            :loading="enterpriseLoading"
            :lastUpdate="enterpriseLastUpdate"
            :params="appModules.myDecorated"
            @visibleChanged="updateModuleVisible('decoratedCard', $event)"
          ></decorated-card>
        </v-flex>
        <v-flex
          xs12
          md4
          lg4
          v-show="
            segmentedHomeModules.profileCard == null ||
            !!segmentedHomeModules.profileCard
          "
        >
          <profile-card
            :item="profileItem"
            @submit="updateUser"
            :loading="profileLoading"
            :error="profileError"
            :form-loading="profileForm.loading"
            :form-error="profileForm.error"
            :params="appModules.profile"
            :errorText="enums.responses.error"
            :retryFunction="getUser"
            :state="profileState"
            @visibleChanged="updateModuleVisible('profileCard', $event)"
          ></profile-card>
        </v-flex>
        <v-flex
          xs12
          md4
          lg4
          v-show="
            segmentedHomeModules.legalDocsCard == null ||
            !!segmentedHomeModules.legalDocsCard
          "
        >
          <legal-docs-card
            :items="legalDocs"
            :loading="docsLoading"
            :error="docsError"
            :params="appModules.legalDocs"
            :errorText="enums.responses.error"
            :docTypeEnumText="enums.legalDocuments"
            :docTypeEnumValue="enums.legalDocumentsStatusValues"
            @visibleChanged="updateModuleVisible('legalDocsCard', $event)"
            :retryFunction="getDocuments"
          ></legal-docs-card>
        </v-flex>
        <v-flex
          xs12
          md4
          lg4
          v-show="
            (segmentedHomeModules.faqCard == null ||
              !!segmentedHomeModules.faqCard) &&
            visibleModulesCount <= 6
          "
        >
          <faq-card
            :items="faqItems"
            :loading="faqLoading"
            :error="faqError"
            :params="appModules.faq"
            :errorText="enums.responses.error"
            fromHome
            @faqSelected="goToFaq"
            @visibleChanged="updateModuleVisible('faqCard', $event)"
            :retryFunction="getFaqs"
          ></faq-card>
        </v-flex>
        <v-flex
          xs12
          md4
          lg4
          v-show="
            segmentedHomeModules.appointmentCard == null ||
            !!segmentedHomeModules.appointmentCard
          "
        >
          <appointment-card
            :loading="enterpriseLoading"
            :params="appModules.appointment"
            :errorText="enums.responses.error"
            @visibleChanged="updateModuleVisible('appointmentCard', $event)"
          ></appointment-card>
        </v-flex>
        <v-flex
          xs12
          md4
          lg4
          v-show="
            segmentedHomeModules.unitDocsCard == null ||
            !!segmentedHomeModules.unitDocsCard
          "
        >
          <product-docs-card
            :loading="enterpriseLoading"
            :params="appModules.productDocs"
            :errorText="enums.responses.error"
            @visibleChanged="updateModuleVisible('unitDocsCard', $event)"
          ></product-docs-card>
        </v-flex>
        <v-flex
          xs12
          md4
          lg4
          v-show="
            segmentedHomeModules.bankLoanCard == null ||
            !!segmentedHomeModules.bankLoanCard
          "
        >
          <bank-loan-card
            :loading="enterpriseLoading"
            :params="appModules.bankLoan"
            :errorText="enums.responses.error"
            @visibleChanged="updateModuleVisible('bankLoanCard', $event)"
          ></bank-loan-card>
        </v-flex>
      </template>
    </v-layout>
  </div>
</template>

<script>
import enums from '@/utils/enums';
import bus from '@/utils/bus';
import { APP, CONFIG, UNIT, IFRAME, USER } from '@/utils/constants';
import Banner from '@/components/Banner';
import UnitsSelect from '@/components/unitsSelect/UnitsSelect';
import ProfileCard from '@/components/modules/ProfileCard';
import FinancialSummaryCard from '@/components/modules/FinancialSummaryCard';
import FaqCard from '@/components/modules/FaqCard';
import SupportCard from '@/components/modules/SupportCard';
import PaymentSlipCard from '@/components/modules/PaymentSlipCard';
import MyEnterpriseCard from '@/components/modules/MyEnterpriseCard';
import DecoratedCard from '@/components/modules/DecoratedCard';
import ConstructionCard from '@/components/modules/ConstructionCard';
import AppointmentCard from '@/components/modules/AppointmentCard';
import BankLoanCard from '@/components/modules/BankLoanCard';
import LegalDocsCard from '@/components/modules/LegalDocsCard';
import ProductDocsCard from '@/components/modules/ProductDocsCard';
import ModuleCard from '@/components/layout/Card';
import WarningCompliance from '@/components/lgpd/Warning';
import Modal from '@/components/layout/Modal';
import requestService from '@/services/request';

import bannerMixin from '@/mixins/banner';
import newsVideosMixin from '@/mixins/newsVideo';
import faqMixin from '@/mixins/modules/faq';
import docsMixin from '@/mixins/modules/docs';
import eventsMixin from '@/mixins/modules/events';
import supportMixin from '@/mixins/modules/support';
import profileMixin from '@/mixins/modules/profile';
import enterpriseMixin from '@/mixins/modules/enterprise';
import financialSummaryMixin from '@/mixins/modules/financialSummary';
import toExpirePaymentSlipMixin from '@/mixins/modules/toExpirePaymentSlip';
import anticipationPaymentSlipMixin from '@/mixins/modules/anticipationPaymentSlip';
import latePaymentSlipMixin from '@/mixins/modules/latePaymentSlip';

export default {
  name: 'home',
  mixins: [
    bannerMixin,
    newsVideosMixin,
    profileMixin,
    financialSummaryMixin,
    faqMixin,
    supportMixin,
    toExpirePaymentSlipMixin,
    enterpriseMixin,
    anticipationPaymentSlipMixin,
    latePaymentSlipMixin,
    docsMixin,
    eventsMixin,
  ],
  components: {
    Banner,
    UnitsSelect,
    ProfileCard,
    FinancialSummaryCard,
    FaqCard,
    SupportCard,
    PaymentSlipCard,
    MyEnterpriseCard,
    DecoratedCard,
    ConstructionCard,
    AppointmentCard,
    BankLoanCard,
    LegalDocsCard,
    ProductDocsCard,
    ModuleCard,
    WarningCompliance,
    Modal,
  },
  computed: {
    segmentedHomeModules() {
      return this.modulesVisibled;
    },
    visibleModulesCount() {
      return Object.values(this.segmentedHomeModules).filter((v) => v).length;
    },
    unitSegmentations() {
      return this.$store.getters[UNIT.GET_SEGMENTATIONS];
    },
    enterpriseThemeColor() {
      const { myEnterprise, constructionProgress } = this.appModules;
      return myEnterprise.themeColor === constructionProgress.themeColor
        ? myEnterprise.themeColor
        : '';
    },
    underConstruction() {
      if (!this.enterpriseStage) return this.enterpriseStage;
      return (
        enums.underConstructionStages.find(
          (o) => o === this.enterpriseStage
        ) !== undefined
      );
    },
    popups() {
      return this.$store.getters[CONFIG.GET_POPUPS];
    },

    myEnterpriseIframeUrl() {
      return this.$store.getters[IFRAME.GET_MY_ENTERPRISE_CARD_URL];
    },
    decoratedIframeUrl() {
      return this.$store.getters[IFRAME.GET_DECORATED_CARD_URL];
    },
    constructionIframeUrl() {
      return this.$store.getters[IFRAME.GET_CONSTRUCTION_CARD_URL];
    },
    config() {
      return this.$store.getters[CONFIG.GET];
    },
    compliance() {
      return this.$store.getters[CONFIG.GET_COMPLIANCE];
    },
    appModules() {
      return this.$store.getters[APP.APP_MODULES];
    },
    isActive() {
      return this.$store.getters[CONFIG.GET_IS_COMPLIANCE_ACTIVE];
    },
    isActiveAdmin() {
      return this.$store.getters[CONFIG.GET_IS_COMPLIANCE_ACTIVE_ADMIN];
    },
    complianceUser() {
      return this.$store.getters[USER.HAS_COMPLIANCE];
    },
    acceptedPolicyPrivacy() {
      return sessionStorage.getItem('acceptedPolicyPrivacy');
    },
    adminAcceptedPopup() {
      return sessionStorage.getItem('adminAcceptedPopup');
    },
    userPopUps() {
      return this.$store.getters[USER.GET_USER_POPUPS];
    },
    visiblesPopups() {
      if (this.$store.getters[APP.IS_ADMIN_PREVIEW]) {
        if (this.adminAcceptedPopup) return [];
        return this.popups.filter((popup) => popup.isActiveAdmin);
      }

      return this.popups.filter((popup) => {
        if (!popup.isActive) return false;

        let userPopup = false;

        // verify if popup is active to clients
        if (this.userPopUps && this.userPopUps.popupsIds > 0) {
          userPopup = this.userPopUps.popupsIds.find(
            (popupId) => popupId == popup.id
          );
        }
        // verify if user has popup
        if (!userPopup) return true; // if user has not popup, show it
        if (popup.lastModified > this.userPopUps.dontShowAgainAt) {
          // if user has popup and it was modified after user dontShowAgainAt, show it
          return true;
        }
      });
    },
  },
  data: () => ({
    gettingModulesInfos: false,
    modulesVisibled: {},
    visible: false,
    modalPopup: true,
    dontShowAgainPopup: false,
  }),
  created() {
    bus.$on('unit:change', this.onUnitChange);
    bus.$on('unit:update', this.onUnitUpdate);
  },
  // important to be on this lifecicle hook,
  // in order to prevent calling modules methods twice.
  mounted() {
    this.getModulesInfos();
    this.isVisible();
  },
  beforeDestroy() {
    bus.$off('unit:change', this.onUnitChange);
    bus.$off('unit:update', this.onUnitUpdate);
  },
  methods: {
    isVisible() {
      if (!this.$store.getters[APP.IS_ADMIN_PREVIEW] && this.isActive) {
        this.visible = true;
      } else if (
        this.$store.getters[APP.IS_ADMIN_PREVIEW] &&
        this.isActiveAdmin
      ) {
        this.visible = true;
      } else {
        this.visible = false;
      }
    },

    dontShowAgain(value) {
      this.dontShowAgainPopup = value;
    },

    async acceptedFunction() {
      if (!this.$store.getters[APP.IS_ADMIN_PREVIEW]) {
        const { _id, userRole } = this.$store.getters[USER.GET_USER];
        const data = {
          compliance: {
            version: this.compliance.version,
          },
          userRole: userRole,
          user: { _id },
        };

        await requestService(
          `${process.env.AUTH_API_URL}/user/updateUser`,
          'POST',
          {
            data,
          }
        );

        this.createTrace(this.enums.logTraceActions.acceptedPrivacyPolity, {
          version: this.compliance.version,
        });
      } else {
        sessionStorage.setItem('acceptedPolicyPrivacy', true);
      }
    },

    async acceptedPopUpFunction(id, title, description) {
      this.modalPopup = false;

      const { _id, userRole } = this.$store.getters[USER.GET_USER];
      const now = new Date();

      this.createTrace(this.enums.logTraceActions.acceptedPopup, {
        id: id,
        title: title,
        description: description,
      });

      if (this.dontShowAgainPopup) {
        if (!this.$store.getters[APP.IS_ADMIN_PREVIEW]) {
          let popupsIds = [];

          if (this.userPopUps && this.userPopUps.popupsIds) {
            popupsIds = this.userPopUps.popupsIds;
          }

          const data = {
            userRole: userRole,
            user: { _id },
            popups: {
              popupsIds: [...new Set([...popupsIds, id])],
              dontShowAgainAt: now, //date of the click
            },
          };

          await requestService(
            `${process.env.AUTH_API_URL}/user/updateUser`,
            'POST',
            {
              data,
            }
          );
        } else {
          sessionStorage.setItem('adminAcceptedPopup', true);
        }

        this.createTrace(this.enums.logTraceActions.dontShowPopupAgain, {
          id: id,
          title: title,
          description: description,
        });
      }
    },

    onUnitChange() {
      this.getModulesInfos(true);
    },
    onUnitUpdate() {
      this.getModulesInfos();
    },
    async getModulesInfos(unitChange = false) {
      if (!unitChange && this.gettingModulesInfos) {
        return;
      }
      if (!this.selectedUnit) {
        return;
      }
      this.modulesVisibled = {};

      this.gettingModulesInfos = true;
      const eventTypes = [
        'generic',
        'inspection',
        'agi',
        'allocationEquityAssembly',
        'allocationEquityVisit',
      ];
      const promises = [
        this.getBanners(),
        this.getNewsVideos(),
        this.getUser(),
        this.getFinancialSummary(),
        this.getFaqs(),
        this.getTourUrl(),
        this.getDocuments(),
      ];
      if (!this.$store.getters[UNIT.GET_SELECTED].keyDeliveryDate) {
        eventTypes.push('keyDelivery');
      }
      promises.push(this.getEvent(eventTypes, { onlyCount: false }));

      await Promise.all(promises)
        .then(() => {
          this.getToExpirePaymentSlips();
          this.getLateSolicitations();
          this.getAnticipationSolicitations();
          this.getOctadeskAllProposersTickets();
        })
        .finally(() => {
          this.gettingModulesInfos = false;
        });
    },
    updateModuleVisible(field, value) {
      if (!this.modulesVisibled) {
        this.modulesVisibled = {};
      }
      if (this.modulesVisibled[field] != value) {
        this.modulesVisibled = { ...this.modulesVisibled, [field]: value };
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../assets/scss/breakpoint';

.cards-area {
  padding: 1em;
  margin: 0 auto;
  width: 100%;

  &__lg {
    max-width: 1366px;
  }
  @include breakpoint(mobile) {
    width: 100%;
  }

  .flex.md4,
  .flex.lg4 {
    padding: 0.5em;

    @include breakpoint(mobile) {
      padding: 0.5em 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Home.vue